import styles from './ProductFeatures.module.css'
import clsx from 'clsx'
import { BasicStyledComponent, DSProductFeatureProps } from 'shared-definitions/types'
import ProductFeature from 'shared-components/ui/ProductFeature'

interface ProductFeaturesProps extends BasicStyledComponent {
  vars: DSProductFeatureProps[]
}

const ProductFeatures: React.VFC<ProductFeaturesProps> = ({ className, vars }) => {
  if (!vars.length) {
    return null
  }
  return (
    <div className={clsx(styles.container, className)}>
      {vars.map((item, index) => (
        <ProductFeature feature={item} key={index} />
      ))}
    </div>
  )
}

export default ProductFeatures
